module.exports = __webpack_public_path__ + "static/img/COC2021-5.4cbba74.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/meeting/COC2021-5.jpg
// module id = Lg/0
// module chunks = 0